import axios from '@/app/axios'
import Country from '@/locations/models/country'
import Responses from '@/app/utils/responses'

class CountriesService {
  // TODO: Aus der DB laden.
  public async loadAllAsync() {
    const res = await axios.get<string[]>(`countries/all`)
    return Responses.list(res)
  }
}

export default new CountriesService()
